import React from "react";
import { Loader2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const TONES = {
  primary: "bg-blue-600 text-white border-blue-600 hover:bg-blue-700",
  success: "bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700",
  warning: "bg-amber-500 text-white border-amber-500 hover:bg-amber-600",
  dark: "bg-zinc-950 text-white border-zinc-950 hover:bg-zinc-800",
  neutral: "bg-white text-zinc-700 border-zinc-200 hover:bg-zinc-100 hover:text-zinc-950",
  danger: "bg-white text-red-600 border-red-200 hover:bg-red-50",
  dangerSoft: "bg-white text-amber-700 border-amber-200 hover:bg-amber-50",
  emeraldSoft: "bg-emerald-50 text-emerald-800 border-emerald-200 hover:bg-emerald-100",
  amberSoft: "bg-amber-50 text-amber-900 border-amber-300 hover:bg-amber-100",
  redSoft: "bg-red-50 text-red-800 border-red-300 hover:bg-red-100",
  blueSoft: "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100",
  skySoft: "bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100",
};

// Square icon button with a hover tooltip describing the action.
export default function IconAction({
  icon: Icon, label, onClick, href, target, testid, tone = "neutral",
  disabled = false, loading = false, size = "md", className = "",
}) {
  const dim = size === "lg" ? "w-10 h-10" : size === "sm" ? "w-7 h-7" : "w-8 h-8";
  const cls = `inline-flex items-center justify-center ${dim} rounded-md border transition-[background-color,transform] duration-150 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed ${TONES[tone]} ${className}`;
  const content = loading ? <Loader2 size={14} className="animate-spin" /> : <Icon size={14} strokeWidth={2} />;
  const el = href ? (
    <a href={href} target={target} rel={target ? "noopener noreferrer" : undefined} onClick={onClick} aria-label={label} data-testid={testid} className={cls}>{content}</a>
  ) : (
    <button type="button" onClick={onClick} disabled={disabled || loading} aria-label={label} data-testid={testid} className={cls}>{content}</button>
  );
  return (
    <TooltipProvider><Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        {/* disabled buttons swallow pointer events → wrap them so the tooltip still explains why */}
        {disabled || loading ? <span className={`inline-flex ${className}`} tabIndex={0}>{el}</span> : el}
      </TooltipTrigger>
      <TooltipContent side="bottom" className="bg-zinc-950 text-white text-[11px] max-w-[240px] text-center">{label}</TooltipContent>
    </Tooltip></TooltipProvider>
  );
}
